import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '@/hooks/useLanguage'
import { useLoading } from '@/store/contexts/LoadingContext'
import { t } from '@/utils/i18n'
import PageHeader from '@/components/common/PageHeader/PageHeader'
import Card from '@/components/common/Card/Card'
import './Privacy.css'

function Privacy() {
  const navigate = useNavigate()
  const { language } = useLanguage()
  const { stopLoading } = useLoading()

  useEffect(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => stopLoading())
    })
  }, [stopLoading])

  return (
    <div className="privacy">
      <PageHeader showBack={false} onBack={() => navigate(-1)} />
      <div className="privacy__content">
        <Card className="privacy__card">
          <div className="privacy__section">
            <h2>{t('privacy.title', language) || 'Dreamity 개인정보처리방침'}</h2>
            <p className="privacy__last-updated">
              {t('privacy.lastUpdated', language) || '최종 수정일: 2026년 2월 1일'}
            </p>
            <p className="privacy__summary">
              {language === 'ko'
                ? 'Dreamity는 서비스 제공·회원 관리 목적으로 최소한의 개인정보만 처리하며, 목적 달성 시 파기합니다.'
                : 'Dreamity processes only the minimum personal data necessary for service provision and member management, and destroys it when the purpose is achieved.'}
            </p>
          </div>

          <div className="privacy__section">
            {language === 'ko' ? (
              <>
                <h3>제1조 (처리 목적·항목·보유기간)</h3>
                <p>
                  처리 목적: 서비스 제공, 회원 관리, 문의 처리. 수집 항목: 사용자 이름(필수), 프로필 등 선택항목. 보유: 회원 탈퇴 시까지. 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관합니다.
                </p>
              </>
            ) : (
              <>
                <h3>Article 1 (Purpose, Items, Retention)</h3>
                <p>
                  Purpose: service provision, member management, inquiries. Items: username (required), profile etc. (optional). Retained until withdrawal. Longer retention only when required by law.
                </p>
              </>
            )}
          </div>

          <div className="privacy__section">
            {language === 'ko' ? (
              <>
                <h3>제2조 (제3자 제공·위탁)</h3>
                <p>
                  원칙적으로 제3자에게 제공하지 않습니다. 이용자 동의 또는 법령에 따른 경우 예외입니다. 업무 위탁 시 필요한 범위에서만 위탁하며, 위탁처에 대해 관리·감독합니다.
                </p>
              </>
            ) : (
              <>
                <h3>Article 2 (Third-Party Provision and Outsourcing)</h3>
                <p>
                  Not provided to third parties in principle. Exceptions: user consent or as required by law. Outsourcing is limited to what is necessary and subject to oversight.
                </p>
              </>
            )}
          </div>

          <div className="privacy__section">
            {language === 'ko' ? (
              <>
                <h3>제3조 (권리 행사·파기·문의)</h3>
                <p>
                  이용자는 열람·정정·삭제·처리정지 요청 권리가 있으며, 요청 시 서비스 정책에 따라 처리합니다. 불필요한 정보는 지체 없이 파기합니다.
                </p>
              </>
            ) : (
              <>
                <h3>Article 3 (Rights, Destruction, Contact)</h3>
                <p>
                  Users may request access, correction, deletion, or suspension of processing; requests are handled per service policy. Unnecessary data is destroyed without delay.
                </p>
              </>
            )}
          </div>

          <div className="privacy__section">
            {language === 'ko' ? (
              <>
                <h3>제4조 (안전조치·방침 변경)</h3>
                <p>
                  개인정보의 안전을 위해 필요한 기술·관리적 조치를 취합니다. 본 방침은 변경될 수 있으며, 변경 시 서비스 내 공지 등으로 안내합니다.
                </p>
              </>
            ) : (
              <>
                <h3>Article 4 (Security and Policy Changes)</h3>
                <p>
                  Necessary technical and administrative measures are taken to protect personal data. This policy may be changed; changes will be announced via the service.
                </p>
              </>
            )}
          </div>
        </Card>
      </div>
    </div>
  )
}

export default Privacy
